import { gql } from '@apollo/client'

export const CREATE_CHAT_TOKEN = gql`
  mutation createChatToken {
    createChatToken {
      value
    }
  }
`
